<template>
    <div :class="{'the-nav': true, 'is-not-collapse': !isCollapse, 'is-collapse': isCollapse }">
        <!-- Menu -->
        <el-tooltip effect="dark" :content="$_isCollapse()?'收起':'展开'" placement="right" :disabled="!$_isCollapse()"
            transition="none">
            <div class="the-nav-menu" @click="$_changeCollapse()">
                <div class="icon"><i class="iconfont okp-caidan"></i></div>
            </div>
        </el-tooltip>

        <!-- Content -->
        <div v-for="(row, rowIndex) in filterModule" :key="rowIndex"
            :class="{ 'the-nav-row': true, 'focus': option.collapse?(navFocusIndex==rowIndex):true}">
            <template v-if="row.items">
                <el-tooltip v-if="option.collapse" effect="dark" :content="row.label" placement="right"
                    :disabled="!$_isCollapse()" transition="none">
                    <div class="the-nav-directory" @click="$_changeFocus(rowIndex)">
                        <div class="icon"><i
                                :class="{'iconfont':true, 'okp-sanjiaoxing-right':navFocusIndex!=rowIndex, 'okp-sanjiaoxing-down':navFocusIndex==rowIndex}"></i>
                        </div>
                        <div class="label" v-if="!$_isCollapse()">{{row.label}}</div>
                    </div>
                </el-tooltip>

                <el-tooltip v-for="(item, index) in row.items" :key="index" effect="dark" :content="item.label"
                    placement="right" :disabled="!$_isCollapse()" transition="none">
                    <div :class="{'the-nav-item': true, 'selected': $_isSelected(item.name)}"
                        @click="$router.push({name: item.name})">
                        <div class="icon"><i :class="`iconfont ${item.icon}`"></i></div>
                        <div class="label" v-if="!$_isCollapse()">{{item.label}}</div>
                    </div>
                </el-tooltip>
            </template>
            <template v-else>
                <el-tooltip effect="dark" :content="row.label" placement="right" :disabled="!$_isCollapse()"
                    transition="none">
                    <div :class="{'the-nav-item': true, 'selected': $_isSelected(row.name)}"
                        @click="$router.push({name: row.name})">
                        <div class="icon"><i :class="`iconfont ${row.icon}`"></i></div>
                        <div class="label" v-if="!$_isCollapse()">{{row.label}}</div>
                    </div>
                </el-tooltip>
            </template>

        </div>

        <!-- User -->
        <el-popover width="150" placement="right" :visible-arrow="false" trigger="hover"
            popper-class="the-nav-pop-over">
            <template>
                <div v-if="userType == 'partner'" class="flex-row-center-start" style="margin: 10px 0;">
                    <el-button size="mini" type="primary" round @click="dialog.editAdmin.methods.open">修改管理员信息
                    </el-button>
                </div>
                <div class="flex-row-center-start" style="margin: 10px 0;">
                    <el-button size="mini" type="primary" round @click="dialog.changePwd.methods.open">修改密码</el-button>
                </div>
                <div class="flex-row-center-start" style="margin: 10px 0;">
                    <el-button size="mini" type="danger" round @click="$_logout">退出</el-button>
                </div>
            </template>

            <div :class="{'the-nav-item':true, 'selected ': false, 'the-nav-user': true}" slot="reference">
                <div class="icon"><i class="iconfont okp-fonts-user"></i></div>
                <div class="label" v-if="!isCollapse">{{username}}</div>
            </div>
        </el-popover>

        <!-- ChangePSW -->
        <mc-dialog :dialog-option.sync="dialog.changePwd">
            <template slot="content">
                <mc-layout-row label-text="新密码" :label-width="150">
                    <el-input v-model="dialog.changePwd.data.new_password" type="password"
                        @keyup.enter.native="$_changePwd()"></el-input>
                </mc-layout-row>
                <mc-layout-row label-text="确认新密码" :label-width="150">
                    <el-input v-model="dialog.changePwd.data.new_password_confirm" type="password"
                        @keyup.enter.native="$_changePwd()"></el-input>
                </mc-layout-row>
                <mc-label icon="el-icon-warning" warn>密码为6-20位数字、字母或特殊字符.@#组合（不能为纯数字）</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.editAdmin">
            <template slot="content">
                <mc-layout-row label-text="邮箱" :label-width="150" important>
                    <el-input v-model="dialog.editAdmin.data.newEmail"></el-input>
                </mc-layout-row>
                <mc-layout-row label-text="联系方式" :label-width="150" important>
                    <el-input v-model="dialog.editAdmin.data.newTel"></el-input>
                </mc-layout-row>
            </template>
        </mc-dialog>
    </div>
</template>

<script>
    import configNav from '@/config/theNav.js'
    import {
        async
    } from 'q';
    const log = new Log("Components/the-nav");
    export default {
        name: "the-nav",
        data() {
            return {
                userType: '',
                option: {
                    collapse: true,
                },
                navFocusIndex: 0,
                navList: configNav,
                dialog: {
                    changePwd: {
                        visible: false,
                        title: "修改密码",
                        style: {
                            width: "440px",
                        },
                        methods: {
                            open: () => {
                                this.dialog.changePwd.data.old_password = null;
                                this.dialog.changePwd.data.new_password = null;
                                this.dialog.changePwd.data.new_password_confirm = null;
                                this.dialog.changePwd.visible = true;
                            },
                            confirm: () => {
                                this.$_changePwd();
                            },
                        },
                        data: {
                            old_password: null,
                            new_password: null,
                            new_password_confirm: null,
                        },
                    },
                    editAdmin: {
                        visible: false,
                        title: "修改管理员信息",
                        style: {
                            width: "440px",
                        },
                        methods: {
                            open: () => {
                                this.dialog.editAdmin.data.newEmail = null;
                                this.dialog.editAdmin.data.newTel = null;
                                this.dialog.editAdmin.visible = true;
                                this.$_getAdminInfo();
                            },
                            confirm: () => {
                                this.$_changeAdminInfo();
                            },
                        },
                        data: {
                            newEmail: null,
                            newTel: null,
                        },
                    },
                },
            };
        },
        computed: {
            isCollapse() {
                return this.$store.state.nav.isCollapse;
            },
            authority() {
                return window.sessionStorage.userType;
            },
            username() {
                return window.sessionStorage.username;
            },
            filterModule() {
                let arr = [];
                this.navList.map(item => {
                    if (item.authority.indexOf(this.authority) > -1) arr.push(item);
                });
                return arr;
            },
        },
        methods: {
            $_isCollapse() {
                return this.isCollapse;
            },
            $_changeCollapse() {
                this.$store.state.nav.isCollapse = !this.$store.state.nav.isCollapse;
            },
            $_changeFocus(target) {
                if (this.navFocusIndex == target) this.navFocusIndex = null;
                else this.navFocusIndex = target;
            },
            $_isSelected(val) {
                // if(this.$route.name.indexOf(val)>-1) return true;
                if (this.$route.name.slice(0, val.length) == val) return true;
                else return false;
            },
            $_logout() {
                this.$router.push({
                    name: "login"
                });
            },
            $_changePwd: async function () {
                if (!this.dialog.changePwd.data.new_password) {
                    this.$message.warning("请输入新密码");
                    return
                }
                 if (!this.dialog.changePwd.data.new_password_confirm) {
                    this.$message.warning("请确认新密码");
                    return
                }
                let reg = new RegExp(/^(?![0-9]+$)[0-9A-Za-z.@#]{6,20}$/);
                if (this.dialog.changePwd.data.new_password !== this.dialog.changePwd.data.new_password_confirm) {
                    this.$message.error("两次输入的密码不一致");
                    return
                }
                if (this.dialog.changePwd.data.new_password.length < 6 || this.dialog.changePwd.data.new_password.length >20) {
                    this.$message.error("请输入6-20位的密码");
                    return
                }
                if (reg.test(this.dialog.changePwd.data.new_password) === false) {
                    this.$message.error("请使用正确的密码组合");
                    return
                }
                let params = {
                    login_password: this.dialog.changePwd.data.new_password
                };
                if (this.userType == "user") {
                    let data = await this.$api.user.changeUserPwd.call(this, params)
                    if (data !== false) {
                        this.$message.success("修改成功.");
                        this.dialog.changePwd.visible = false;
                    }
                } else {
                    let data = await this.$api.user.changeAdminPwd.call(this, params)
                    if (data !== false) {
                        this.$message.success("修改成功.");
                        this.dialog.changePwd.visible = false;
                    }
                }
            },
            $_changeAdminInfo: async function () {
                let reg = new RegExp(/^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/);
                let tel_reg = new RegExp(/^1([38]\d|5[0-35-9]|7[3678])\d{8}$/)
                let params = {
                    email: this.dialog.editAdmin.data.newEmail,
                    mobile: this.dialog.editAdmin.data.newTel
                }
                if (params.email == "") {
                    this.$message.warning("请输入邮箱.");
                    return
                }
                if (reg.test(params.email) == false) {
                    this.$message.warning("登陆账号格式错误，请填写邮件格式.");
                    return
                }
                if (params.mobile == "") {
                    this.$message.warning("请输入手机号码.");
                    return
                }
                if (tel_reg.test(params.mobile) == false) {
                    this.$message.warning("手机号码格式错误，请填写正确的手机号码.");
                    return
                }
                let data = await this.$api.user.changeAdminInfo.call(this, params)
                if (data !== false) {
                    this.$message.success("修改成功.");
                    this.dialog.editAdmin.visible = false;
                }
            },
            $_getAdminInfo: async function () {
                let params = {}
                let data = await this.$api.user.getAdminInfo.call(this, params)
                if (data !== false) {
                    this.dialog.editAdmin.data.newEmail = data.email
                    this.dialog.editAdmin.data.newTel = data.mobile
                }
            },
            $_locationCurrentPosition() {
                if (this.option.collapse) {
                    let rst = null;
                    let current = this.$route.name;
                    this.filterModule.map((dir, index) => {
                        if (dir.items) {
                            dir.items.map(item => {
                                if (item.name == current) rst = index;
                            })
                        } else {
                            if (dir.name == current) rst = index;
                        }
                    })
                    return rst;
                }
            },
        },
        mounted() {
            this.navFocusIndex = this.$_locationCurrentPosition();
            this.userType = window.sessionStorage.userType
        },
        components: {},
    }
</script>

<style lang="less">
    @import url("../style/color.less");
    @import url("../style/common.less");
    @NavItemHeight: 40px;
    @NavNotCollapseWidth: 200px;
    @NavCollapseWidth: 50px;

    .the-nav {
        position: relative;
        height: 100%;
        background-color: @Color-Primary;

        &.is-not-collapse {
            .the-nav-menu {
                .icon {
                    i {
                        animation: NotCollapse 0.25s;
                        transform: rotate(90deg);
                    }
                }
            }
        }

        &.is-collapse {
            .the-nav-menu {
                .icon {
                    i {
                        animation: IsCollapse 0.25s;
                    }
                }
            }
        }
    }

    .the-nav-row {
        width: 100%;
        height: @NavItemHeight;
        overflow: hidden;

        &.focus {
            height: auto;
        }
    }

    .the-nav-item {
        .flex-row-center-center;
        width: 100%;
        height: @NavItemHeight;
        user-select: none;
        cursor: pointer;

        .icon {
            .flex-row-center-center;
            width: @NavCollapseWidth;
            height: 100%;
            color: #fff;
            user-select: none;

            i {
                font-size: 16px;
                text-align: center;
            }
        }

        .label {
            .flex-row-start-center;
            // width: ~"calc(100% - @{NavCollapseWidth})";
            width: @NavNotCollapseWidth - @NavCollapseWidth;
            height: 100%;
            color: #fff;
            user-select: none;
        }

        &:hover {
            background-color: @Color-Primary-Deep;
        }

        &:focus {
            outline-style: none;
        }

        &.selected {
            background-color: @Color-Highlight;
        }
    }

    .the-nav-directory {
        .the-nav-item;
        background-color: @Color-Primary-Light;

        .icon {
            i {
                font-size: 10px;
            }
        }

        &:hover {
            background-color: @Color-Primary-Light;

            .icon {
                font-weight: 600;
            }
        }
    }

    .the-nav-menu {
        .the-nav-item;
        height: @NavItemHeight - 10px;
        background-color: @Color-Primary-Light;
        opacity: 0.6;
    }

    .the-nav-user {
        .the-nav-item;
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .the-nav-pop-over {
        padding: 0 10px;
        background-color: @Color-Primary-Light;

        .the-nav-pop-over-hr {
            border-top: 0;
            border-bottom: 1px solid #ddd;
        }
    }

    .the-nav-dialog-row {
        .flex-row-start-center;
        width: 100%;
        height: 40px;
        margin-bottom: 15px;

        &:last-child {
            margin-bottom: 0;
        }

        .label {
            .flex-row-start-center;
            width: 100px;
            height: 100%;
        }

        .input {
            .flex-row-start-center;
            width: ~"calc(100% - 100px)";
            height: 100%;
        }
    }

    // animation
    @keyframes NotCollapse {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(90deg);
        }
    }

    @keyframes IsCollapse {
        from {
            transform: rotate(90deg);
        }

        to {
            transform: rotate(0deg);
        }
    }

    @media print {
        .the-nav {
            display: none;
        }
    }
</style>